module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageNotFound",
    attrs: {
      "id": "status404"
    }
  }, [_c('BackgroundImage', {
    attrs: {
      "url": "page-not-found.jpg",
      "lowResUrl": "page-not-found-lowres.jpg",
      "color": "#a2dff5"
    }
  }), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "contents m-t-4 container-fluid"
  }, [_c('div', {
    staticClass: "col-md-6 centerCol"
  }, [_c('Card', {
    staticClass: "pageNotFoundCard"
  }, [_c('div', {
    slot: "title"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.t('The page you were looking for was not found')))])]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "text-xs-center m-t-2"
  }, [_c('p')]), _vm._v(" "), _c('div', {
    staticClass: "actions m-t-2 text-xs-center"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": ("/" + _vm.language)
    }
  }, [_vm._v(_vm._s(_vm.t('go to Home')))])], 1)])])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dcd2dee4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcd2dee4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NotFound.vue
// module id = 805
// module chunks = 3